import { IonIcon } from '@ionic/react';
import { chevronForward } from 'ionicons/icons';
import { FC } from 'react';

interface MenuUserInfoProps {
  aliasName?: string;
  onProfileClick?: () => void;
}

const MenuUserInfo: FC<MenuUserInfoProps> = ({ aliasName, onProfileClick }) => (
  <div className="side-menu-userinfo" onClick={onProfileClick}>
    <div className="username">{aliasName || 'Anonymous'}</div>
    <IonIcon
      icon={chevronForward}
      style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.75)',
        cursor: 'pointer',
        flexShrink: 0,
      }}
    />
  </div>
);

export default MenuUserInfo;
